import { Icon } from "../ui/Icon/Icon";
import { PlatformBadge } from "../ui/PlatformBadge/PlatformBadge";
import { StatusPill } from "../ui/StatusPill/StatusPill";
import styles from "./HeroPreview.module.css";

/**
 * Static hero illustration that mimics the look of a generated draft variant
 * card, angled in 3D with floating overlay pills. Deliberately NOT the app's
 * VariantCard — this keeps the marketing bundle decoupled from app internals
 * and avoids barrel-import risk. Every string here describes behaviour the
 * app actually performs today (in-app draft approval), with no Slack chrome.
 */
export function HeroPreview() {
  return (
    <div className={styles.stage} aria-hidden="true">
      {/* The angled draft variant card */}
      <div className={styles.card}>
        <div className={styles.cardHead}>
          <PlatformBadge platform="ig" size={20} />
          <div className={styles.cardHeadText}>
            <span className={styles.cardKind}>Carousel · 5 slides</span>
            <span className={styles.cardCat}>product_in_use</span>
          </div>
          <StatusPill state="pending" size="sm" />
        </div>

        <div className={styles.media}>
          <span className={styles.mediaLabel}>4:5 · cover</span>
        </div>

        <div className={styles.copy}>
          <p className={styles.hook}>
            Every crew has one. The patch-pocket, hydration-pusher,
            lost-friend-finder.
          </p>
          <p className={styles.body}>
            Built for the rave mom and rave dad of every crew. Back in stock —
            sized for the friend everyone forwards the group chat to.
          </p>
          <p className={styles.hashtags}>#festivalparent #ravemom #ravedad</p>
        </div>

        <div className={styles.note}>
          <Icon name="info" size={12} />
          <span>Hook reuses a phrase from a draft 3 days ago</span>
        </div>

        <div className={styles.meta}>172 chars · 3 hashtags · 1 validator note</div>

        <div className={styles.actions}>
          <span className={`${styles.actionBtn} ${styles.actionPrimary}`}>
            <Icon name="check" size={13} strokeWidth={3} />
            Approve
          </span>
          <span className={styles.actionBtn}>
            <Icon name="edit" size={13} />
            Edit
          </span>
          <span className={styles.actionBtn}>
            <Icon name="refresh" size={13} />
            Regenerate
          </span>
        </div>
      </div>

      {/* Floating in-app approval status pill */}
      <div className={`${styles.float} ${styles.floatApproved}`}>
        <span className={styles.floatCheck}>
          <Icon name="check" size={14} strokeWidth={3} />
        </span>
        <div className={styles.floatText}>
          <span className={styles.floatTitle}>Approved</span>
          <span className={styles.floatSub}>scheduled to the calendar</span>
        </div>
      </div>

      {/* Floating daily-drafts pill */}
      <div className={`${styles.float} ${styles.floatDaily}`}>
        <span className={styles.floatSpark}>
          <Icon name="sparkles" size={14} />
        </span>
        <div className={styles.floatText}>
          <span className={styles.floatTitle}>3 new drafts</span>
          <span className={styles.floatSub}>IG · FB · TikTok</span>
        </div>
      </div>
    </div>
  );
}
